import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import apiClient from '../api/client';
const VerifyEmailSuccessPage = () => {
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState('Verifying your email...');
    const token = searchParams.get('token');
    const hasVerified = React.useRef(false);
    useEffect(() => {
        const verifyEmail = async () => {
            if (!token) {
                setMessage('No verification token found.');
                return;
            }
            if (hasVerified.current)
                return;
            hasVerified.current = true;
            try {
                await apiClient.get(`/auth/verify-email?token=${token}`);
                setMessage('Email verified successfully! You can now log in.');
            }
            catch (error) {
                setMessage('Failed to verify email. The link may be invalid or expired.');
            }
        };
        verifyEmail();
    }, [token]);
    return (_jsx("div", { className: "min-h-screen flex items-center justify-center", children: _jsxs("div", { className: "max-w-md w-full text-center", children: [_jsx("h1", { className: "text-3xl font-bold mb-4", children: message }), _jsx(Link, { to: "/login", className: "text-blue-500 hover:underline", children: "Go to Login" })] }) }));
};
export default VerifyEmailSuccessPage;
